/* global $R */

const formatPlugin = {
  /**
   * Initialize the plugin, this will add buttons, modals etc.
   * @return {void}
   */
  init(app) {
    this.toolbar = app.toolbar;
    this.app = app;
  },

  start() {
    const $button = this.toolbar.addButton(this.key, {
      title: this.title,
      api: `plugin.${this.key}.show`,
    });

    $button.setIcon(`<i class="${this.icon} is-${this.key}"></i>`);
  },

  /**
   * Called on clicking the Redactor button
   * @return {void}
   */
  show() {
    this.app.block.format(this.key);
  },
};

$R.add('plugin', 'p ', Object.assign({}, formatPlugin, {
  key: 'p',
  title: 'p',
  icon: 'fas fa-font',
}));

$R.add('plugin', 'h1', Object.assign({}, formatPlugin, {
  key: 'h1',
  title: 'H1',
  icon: 'fas fa-heading',
}));

$R.add('plugin', 'h2', Object.assign({}, formatPlugin, {
  key: 'h2',
  title: 'H2',
  icon: 'fas fa-heading',
}));

$R.add('plugin', 'h3', Object.assign({}, formatPlugin, {
  key: 'h3',
  title: 'H3',
  icon: 'fas fa-heading',
}));
